import React, { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { AppContext } from '../views/context/app'
import AppSidebar from '../components/appSidebar'
import AppHeader from '../components/header'
import Routing from './routing'
import AppFooter from '../components/footer'
import Loading from 'react-fullscreen-loading'
import MultiFileUpload from 'src/components/fileUploader'
import ContentModal from 'src/views/container/cms/ContentModal'
import { isEmpty } from 'lodash'
import ArtistModal from 'src/components/artistModal/artistModal'
import VenueModal from 'src/components/venueModal/venueModal'
import PageModal from 'src/components/pageModal/pageModal'
import IPTVchannelModal from 'src/components/IPTVModals/IPTVchannelModal'
import IPTVScheduleModal from 'src/components/IPTVModals/IPTVScheduleModal'
import ContentModalNew from 'src/components/contentModalNew/contentModalNew'

const AppMainContainer = () => {
  const {
    loader,
    uplaodFilesModal,
    contentModalProps,
    artistModalProps,
    venueModalProps,
    pageModalProps,
    iptvModalProps,
    iptvScheduleModalProps,
    contentModalNewProps,
  } = useContext(AppContext)
  const location = useLocation()
  const [isTemplateRoute, setIsTemplateRoute] = useState(false)
  const [isIptvRoute, setIsIptvRoute] = useState(false)

  useEffect(() => {
    setIsTemplateRoute(
      location.pathname.includes('/template-editor/') ||
        location.pathname.includes('/template-preview/') ||
        location.pathname.includes('/static-editor/') ||
        location.pathname.includes('/custom-editor/'),
    )
    setIsIptvRoute(location.pathname.includes('/iptv-schedule/'))
  }, [location])

  return (
    <div>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      {uplaodFilesModal && <MultiFileUpload />}
      {!isEmpty(contentModalProps) && <ContentModal />}
      {!isEmpty(artistModalProps) && <ArtistModal />}
      {!isEmpty(venueModalProps) && <VenueModal />}
      {!isEmpty(pageModalProps) && <PageModal />}
      {!isEmpty(iptvModalProps) && <IPTVchannelModal />}
      {!isEmpty(iptvScheduleModalProps) && <IPTVScheduleModal />}
      {!isEmpty(contentModalNewProps) && <ContentModalNew />}
      <>
        {!isTemplateRoute && <AppSidebar />}
        <div className={!isTemplateRoute && `wrapper d-flex flex-column min-vh-100 bg-light`}>
          {!isTemplateRoute && <AppHeader />}
          <div className={!isTemplateRoute && `body flex-grow-1 px-3`}>
            <Routing isTemplateRoute={isTemplateRoute} isIptvRoute={isIptvRoute} />
          </div>
          {!isTemplateRoute && <AppFooter />}
        </div>
      </>
      {/*)}*/}
    </div>
  )
}

export default AppMainContainer
